import React from 'react';
import HeaderMinimal from '../Shared/Headers/HeaderMinimal';

function Error404() {
	return (
		<>
			<HeaderMinimal />
			<div className="not-found-container">Oups... Cette page n'existe pas</div>
		</>
	);
}

export default Error404;
